import { render, staticRenderFns } from "./PropostasTabela.vue?vue&type=template&id=39e1c48e"
import script from "./PropostasTabela.vue?vue&type=script&lang=js"
export * from "./PropostasTabela.vue?vue&type=script&lang=js"
import style0 from "./PropostasTabela.vue?vue&type=style&index=0&id=39e1c48e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports